import { Panel } from 'primereact/panel';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const i18nMessages = defineMessages({
  noSuperMatches: {
    id: 'account.super-matches.no-super-matches',
    defaultMessage: 'There are currently no SuperMatches',
  },
});

const NoSuperMatches = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel>
            <div className="p-grid">
              <div className="p-col-12 height-full">
                <div className="align-center vertical-align">
                  <h1>{formatMessage(i18nMessages.noSuperMatches)}</h1>
                </div>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default NoSuperMatches;
